import { Icon } from '@iconify/react';
import classNames from 'classnames';
import { ReactNode } from 'react';

type Props = {
  items: ReactNode[];
  className?: string;
};

export const ConnectedList = ({ items, className }: Props) => (
  <ul className={classNames('relative', className)}>
    {items.map((item, index) => (
      <li
        key={index}
        className="relative flex items-start gap-2 pb-3 last:pb-0 before:absolute before:bottom-0 before:left-2 before:top-3 before:w-px before:bg-border last:before:hidden"
      >
        <span className="relative z-10 bg-background p-0.5">
          <Icon icon="mingcute:check-circle-fill" className="size-3.5" />
        </span>
        <span className="text-sm text-muted-foreground">{item}</span>
      </li>
    ))}
  </ul>
);
